import { instanceReadStatistics } from 'client/redux/instance/actionCreators';
import { INSTANCE_SWTD_READ_STATISTICS } from 'client/redux/swtd/constants';

export const instanceSwtdReadStatistics = (id, statistic, query) => dispatch => {
  switch (statistic) {
    default: return dispatch(instanceReadStatistics(INSTANCE_SWTD_READ_STATISTICS, id, statistic, query));
  }
};
